import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

function SinglePayment({ refId }) {

  const formRef = useRef<any>();
  const {employeeProfile}=useSelector((state:any)=>state.userInfo)
  
  useEffect(() => {
    if (!refId) return;
    const submitted: HTMLFormElement | null = document.querySelector('#behpardakhtForm');
    if (submitted) submitted.submit();
  }, [refId]);

  return (
      <form
        ref={formRef}
        id="behpardakhtForm"
        action="https://bpm.shaparak.ir/pgwchannel/startpay.mellat"
        method="post"
        target="_blank"
        className="hidden"
      >
        <input type="text" id="RefId" name="RefId" value={refId} />
        <input
          type="text"
          id="MobileNo"
          name="MobileNo"
          // value={'09917622745'}
          value={employeeProfile?.mobile}
        />
        <input type="submit" />
      </form>

  );
}

export default SinglePayment;
